import { useState } from "react";

export const useModalBehavior = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);

  const openModal = () => setIsOpen(true);
  const onRequestClose = () => setIsOpen(false);

  return { openModal, onRequestClose, isOpen };
};
